import { FormControl } from '@material-ui/core';
import type { TextFieldProps } from '@material-ui/core/TextField';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import React from 'react';
import { v4 } from 'uuid';
import * as Yup from 'yup';

import { DATE_FORMAT } from 'src/constants';
import { FormBodyAPI } from 'src/constants/fieldsTypes';
import { BaseTextField } from 'src/legacy/components/TextField';

// map of error message returned by Yup validation
// to the user friendly error message to show
const dateErrorMessageMap: Record<string, string> = {
  'Invalid Date Format': 'Invalid date format',
};

export const DateTextField: React.FC<TextFieldProps> = (props) => {
  const { error, helperText, value, ...rest } = props;
  const errorMessage = () => {
    if (!error) return ''; // if there is no error return ''
    // if value is empty return required error
    if (!value) return 'Date is required';

    // if helperText is not in the error format map return the original helperText
    if (typeof helperText === 'string') {
      return dateErrorMessageMap[helperText] || helperText;
    }
    return helperText;
  };

  return (
    <BaseTextField
      sizeVariant="medium"
      value={value}
      error={error}
      helperText={errorMessage()}
      {...rest}
    />
  );
};

export const useAddDateForm = () => {
  const validationScheme = Yup.object().shape({
    value: Yup.date().required('Required'),
  });

  const getSubmitValues = async () => ({
    key: v4(),
  });

  const FormRenderer: React.FC<FormBodyAPI> = ({ setFieldValue, values }) => (
    <div>
      <FormControl fullWidth>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            name="value"
            format={DATE_FORMAT}
            value={values.value ? moment(values.value, DATE_FORMAT) : null}
            onChange={(val) => {
              setFieldValue('value', val ? val.format('MM/DD/YYYY') : null);
            }}
            // required because the `textField` slot renders a plain <input />; MUI X v7+ defaults to PickersSectionList
            enableAccessibleFieldDOMStructure={false}
            slots={{ textField: DateTextField }}
            slotProps={{
              textField: { variant: 'outlined', margin: 'none' },
            }}
          />
        </LocalizationProvider>
      </FormControl>
    </div>
  );

  return { validationScheme, getSubmitValues, FormRenderer };
};
